export const RESOURCE_TYPE = [
    {
        "value": "ResTypeLesson",
        "label": "Lesson/Course"
    },
    {
        "value": "ResTypePlan",
        "label": "Lesson Plan/Guide"
    },
    {
        "value": "ResTypeActivity",
        "label": "Activity/Assignment"
    },
    {
        "value": "ResTypeAssess",
        "label": "Assessment/Quiz"
    },

    {
        "value": "ResTypeOther",
        "label": "Other"
    },
];

export const RESOURCE_TYPE_MAP = {
    "ResTypeLesson": {
        "label": "Lesson/Course"
    },
    "ResTypePlan": {
        "label": "Lesson Plan/Guide"
    },
    "ResTypeActivity": {
        "label": "Activity/Assignment"
    },
    "ResTypeAssess": {
        "label": "Assessment/Quiz"
    },
    "ResTypeOther": {
        "label": "Other"
    },
};